<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters>
      <v-col md="2" class="sidebar">
        <ComposeButton />
        <v-btn dark @click="syncEmails" class="mb-4">Sync Mails</v-btn>
        <FolderList />
      </v-col>
      <v-col md="4" class="mailbox">
        <Mailbox />
      </v-col>
      <v-col md="6" class="email-view">
        <EmailView />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Mailbox from "./components/Mailbox.vue"
import EmailView from "./components/EmailView.vue"
import ComposeButton from "./components/ComposeButton.vue"
import FolderList from "./components/FolderList.vue"

export default {
  name: "Mail",
  components: {
    Mailbox,
    EmailView,
    ComposeButton,
    FolderList,
  },
  created() {
    this.$store.dispatch("mailStore/fetchEmails")
    this.$store.dispatch("mailStore/fetchFolders")
    this.$store.dispatch("mailStore/fetchStudios")
    this.$store.dispatch("mailStore/fetchCategories")
  },
  methods: {
    syncEmails() {
      this.$store.dispatch("mailStore/syncEmails")
    },
  },
}
</script>

<style lang="scss" scoped>
.sidebar {
  background-color: #1a1a1a;
  padding: 16px;
}

.mailbox {
  background-color: #212121;
  border-left: 1px solid #3a3a3a;
  border-right: 1px solid #3a3a3a;
}

.email-view {
  background-color: #1a1a1a;
}
</style>
